"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const SvgBolt = (props) => (React.createElement("span", { className: "anticon" },
    React.createElement("svg", Object.assign({ fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", className: "PayPing-icon" }, props),
        React.createElement("path", { d: "m13.039 0.65129-10.387 13.619h9.3486l-1.0387 9.0789 10.387-13.618h-9.3486z" }))));
exports.default = SvgBolt;
//# sourceMappingURL=Bolt.js.map